import Button from 'components/ui/Button/Button';
import Flex from 'components/ui/Flex';
import useAppDispatch from 'hooks/useAppDispatch';
import { OrderCartCheckoutWithAttestation } from 'microshop-api';
import { useTranslation } from 'react-i18next';
import { editEnabledSet, orderSet, skusToBeRemovedSet } from 'store/reducers/orderSlice';

type ActionsProps = {
    editEnabled: boolean;
    handleOnSave: (orderId: number) => void;
    currentOrder: OrderCartCheckoutWithAttestation;
};
export const Actions = ({ editEnabled, handleOnSave, currentOrder }: ActionsProps) => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    return (
        <>
            <Flex className="mt-2 mb-3" justify="end" $gap={6}>
                {!editEnabled && (
                    <Button bgColor="fillGray" onClick={() => dispatch(editEnabledSet(true))}>
                        {t('edit', 'Edit')}
                    </Button>
                )}
                {editEnabled && (
                    <>
                        {' '}
                        <Button
                            bgColor="fillGray"
                            onClick={() => {
                                dispatch(skusToBeRemovedSet([]));
                                dispatch(orderSet(currentOrder));
                            }}
                        >
                            {t('cancel')}
                        </Button>{' '}
                        <Button
                            bgColor="fillGray"
                            onClick={() => {
                                handleOnSave(currentOrder?.orderId!);
                            }}
                        >
                            {t('save')}
                        </Button>
                    </>
                )}
            </Flex>
        </>
    );
};
